export default {
  _o: "allowCrawlerActivity",
  Ro: "baseUrl",
  Wo: "noCookies",
  Vo: "devicePropertyAllowlist",
  Aa: "disablePushTokenMaintenance",
  Yo: "enableLogging",
  Xo: "enableSdkAuthentication",
  qa: "manageServiceWorkerExternally",
  Zo: "minimumIntervalBetweenTriggerActionsInSeconds",
  Wh: "sessionTimeoutInSeconds",
  Vh: "appVersion",
  Kh: "appVersionNumber",
  Ma: "serviceWorkerLocation",
  ka: "safariWebsitePushId",
  Xn: "localization",
  er: "contentSecurityNonce",
  re: "allowUserSuppliedJavascript",
  Jo: "inAppMessageZIndex",
  Do: "openInAppMessagesInNewTab",
  Lh: "requireExplicitInAppMessageDismissal",
  $h: "doNotLoadFontAwesome",
  Jh: "deviceId",
  _a: "serviceWorkerScope",
  Yh: "sdkFlavor",
  tn: "openCardsInNewTab"
};